import * as React from 'react'

function SvgItSoftware(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M20.5 3h-17A1.5 1.5 0 002 4.5v15A1.5 1.5 0 003.5 21h17a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0020.5 3zm.5 16.5a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5V8h18zM21 7H3V4.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5z" />
      <path d="M12 16h5v1h-5zM12 14.06l-5.1 3.69v-1.24l3.39-2.45-3.39-2.45v-1.24l5.1 3.69zM10.29 14.06L6.9 16.51M10.29 14.06L6.9 11.61" />
    </svg>
  )
}

export default SvgItSoftware
